module.exports = __webpack_public_path__ + "img/acmedpos.b85ef38a.png";